import React, { ReactNode } from 'react';
import { FormItemProps, Input, InputProps, TooltipProps } from 'antd';
import { JInputWrapper } from '../JInputWrapper';
import { ValidateStatus } from 'antd/es/form/FormItem';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { Rule } from 'antd/lib/form';

export type JPasswordProps = {
    /**
     * Action to update external module
     * @param value
     */
    onChange?: (value: any) => void;

    /**
     * label
     */
    label?: ReactNode;

    /**
     * name
     */
    name?: string | number | (string | number)[];

    /**
     * nameInput
     */
    nameInput?: string;

    /**
     * value
     */
    value?: string;

    /**
     * type
     */
    type?: string;

    /**
     * placeholder
     */
    placeholder?: string;

    /**
     *   validateStatus
     */
    validateStatus?: ValidateStatus;

    /**
     * errorMessage
     */
    errorMessage?: string;

    /**
     * rules
     */
    rules?: Rule[];

    /**
     * tooltip
     */
    tooltip?: ReactNode | (TooltipProps & { icon: ReactNode });

    /**
     * disabled
     */
    disabled?: boolean;

    /**
     * ant design Form.Item props
     * https://ant.design/components/form/#API
     */
    itemProps?: FormItemProps;

    /**
     * ant design Input props
     * https://ant.design/components/input/#API
     */
    inputProps?: InputProps;

    /**
     * autoComplete
     */
    autoComplete?: string;
};

export const JPasswordField = ({
                                   placeholder,
                                   label,
                                   name,
                                   nameInput,
                                   value,
                                   validateStatus,
                                   errorMessage,
                                   type = 'password',
                                   rules,
                                   tooltip,
                                   disabled = false,
                                   onChange,
                                   itemProps,
                                   inputProps,
                                   autoComplete
                               }: JPasswordProps) => {
    return (<>
            {label ?
                <JInputWrapper
                    label={label}
                    name={name}
                    rules={rules}
                    tooltip={tooltip}
                    validateStatus={validateStatus}
                    help={errorMessage}
                    {...itemProps}
                >
                    <Input.Password
                        autoComplete={autoComplete}
                        disabled={disabled}
                        type={type}
                        name={nameInput}
                        value={value}
                        placeholder={placeholder}
                        onChange={(e) => (onChange ? onChange(e) : '')}
                        {...inputProps}
                    />
                </JInputWrapper> :
                <Input.Password
                    autoComplete={autoComplete}
                    disabled={disabled}
                    type={type}
                    name={nameInput}
                    value={value}
                    placeholder={placeholder}
                    onChange={(e) => (onChange ? onChange(e) : '')}
                    iconRender={visible => (visible ? <EyeTwoTone aria-hidden={true}/> : <EyeInvisibleOutlined aria-hidden={true}/>)}
                    {...inputProps}
                />
            }
        </>
    );
};
